<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="card my-5" style="width:100%">
          <div class="card-body">
            <div class="text-center mt-4 mb-4">
              <img src="../assets/img/hokodo_logo_color.svg" alt="Hokodo" width="200" height="38.5">
            </div>
            <form class="form-signin" v-on:submit.prevent="login">
              <p class="mb-3 text-muted text-center" v-if="message && message === 'logged-out'">You've been logged out</p>
              <p class="mb-3 text-muted text-center" v-else-if="message && message === 'auth'">Please log in to view this page</p>
              <p class="mb-3 text-muted text-center" v-else>Welcome to the Hokodo partner portal.<br>Sign in here to get access to and test our APIs.</p>
              <div class="form-group">
                <input type="email" id="inputEmail" class="form-control" placeholder="Email address" v-model="email" v-bind:class="{ 'is-invalid': (error && error.email) }" required autofocus>
                <div class="mb-3 invalid-feedback" v-if="error && error.email">
                  <p v-for="(description,index) in error.email" :key="index">{{description}}</p>
                </div>
              </div>

              <div class="form-group" @keyup.enter="login">
                <vue-password v-model="password"
                              id="inputPassword"
                              classes="input form-control"
                              placeholder="Password"
                              :disableStrength="true"
                              >
                </vue-password>
                <div class="mb-3 invalid-feedback-password" v-if="error && error.password">
                  <p v-for="(description,index) in error.password" :key="index">{{description}}</p>
                </div>
                <div class="mb-3 invalid-feedback-password" v-if="error && error.non_field_errors">
                  <p v-for="(description,index) in error.non_field_errors" :key="index">{{description}}</p>
                </div>
              </div>
              <p class="mb-3 text-muted text-right"><router-link to="/reset">Forgot your password?</router-link></p>

              <button class="btn btn-lg btn-primary btn-block" type="button" v-on:click="login" :disabled="loading"><icon name="settings" class="feather-spin" v-if="loading"></icon> Sign in to your account</button>
              <p class="mt-5 mb-3 text-muted text-center">Don't have an account? <router-link to="/register">Sign up</router-link></p>
              <hr>
            </form>
          </div>
        </div>
      </div>
    </div>
    <hokodo-footer></hokodo-footer>
  </div>
</template>

<script>
import HokodoFooter from './partials/HokodoFooter'
import VuePassword from 'vue-password'

export default {
  data () {
    return {
      loading: false,
      email: null,
      password: null,
      error: null
    }
  },
  mounted () {

  },
  props: ['message'],
  components: {
    HokodoFooter,
    VuePassword
  },
  methods: {
    login: function () {
      this.loading = true
      this.$store.dispatch('auth/login', {email: this.email, password: this.password}).then(() => {
        // Successfully logged in - redirect the user to Home component
        this.$router.push('/home/account')
      }, (error) => {
        // Login failed
        this.loading = false
        this.error = error
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue